<template>
  <input v-bind="$attrs" v-on="$listeners" >
</template>

<script>
export default {
  name: 'BaseInput',
  components: {},
  mixins: [],
  data() {
    return {}
  },
  computed: {
  },
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/var.scss';
input {
  border: 1px solid rgb(179, 179, 179);
  padding: 0 20px;
  font-size: $fontSize;
  line-height: 1;
  height: 32px;
  border-radius: $borderRaduis;
  width: 124px;
}
input::-webkit-input-placeholder {
  color: $placeHolderColor
}
</style>
